export default __webpack_public_path__ + "static/media/480_dummy2016-consulting01-mobile-de.ee9fb5a6.png";